import { Button } from "@mantine/core";
import { useState } from "react";
import { MultiConfirmationModal as DeleteDataImportRequestsModal } from "../../../../BuildingBlocks/Layout/Modals/MultiConfirmationModal/MultiConfirmationModal";
import type { EnergyDataImportRequest } from "../../../EnergyDataUploadFlow/EnergyDataUpload";

interface DeleteDataImportRequestsButtonProps {
  dataImportRequests: Array<EnergyDataImportRequest>;
  onDeleteMultipleImportRequests: (
    dataImportRequests: Array<EnergyDataImportRequest>
  ) => Promise<void>;
}

function DeleteDataImportRequestsButton({
  dataImportRequests,
  onDeleteMultipleImportRequests
}: DeleteDataImportRequestsButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  function handleClickDelete() {
    return onDeleteMultipleImportRequests(dataImportRequests);
  }

  const dataImportRequestsToDelete = dataImportRequests.map(
    (dataImportRequest) => dataImportRequest.energyDataFile.name
  );

  return (
    <>
      <Button
        disabled={dataImportRequests.length === 0}
        onClick={() => setIsModalOpen(true)}
      >
        {`Datei${dataImportRequestsToDelete.length > 1 ? "en" : ""} löschen`}
      </Button>
      <DeleteDataImportRequestsModal
        actionName="löschen"
        actionObjects={dataImportRequestsToDelete}
        confirmationText="Möchten Sie die folgenden Dateien löschen?"
        isModalOpen={isModalOpen}
        objectName="Dateien"
        toggleModal={() => setIsModalOpen(false)}
        onAction={handleClickDelete}
      />
    </>
  );
}

export { DeleteDataImportRequestsButton };
